import { getAllRoles } from "@/lib/permissions";
import { Check, X, Eye, Pencil } from "lucide-react";

const MODULE_LABELS = {
  dashboard: "Dashboard",
  customers: "Clientes",
  products: "Produtos",
  sales: "Vendas",
  subscriptions: "Assinaturas",
  payments: "Pagamentos",
  chat: "Suporte / Chat",
  operators: "Operadores",
  audit: "Atividades",
};

const ALL_MODULES = Object.keys(MODULE_LABELS);

export default function PermissionsPanel() {
  const roles = getAllRoles();

  return (
    <div data-testid="permissions-panel">
      <h1 className="crm-heading mb-2">Permissões por Cargo</h1>
      <p className="text-sm mb-8" style={{ color: "var(--crm-text-muted)" }}>
        Visualize o que cada cargo pode acessar no CRM.
      </p>

      <div className="crm-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="crm-table">
            <thead>
              <tr>
                <th style={{ minWidth: "140px" }}>Módulo</th>
                {roles.map((r) => (
                  <th key={r.key} className="text-center" style={{ minWidth: "120px" }}>
                    <span className={`crm-badge ${r.key === "admin" ? "crm-badge-red" : r.key === "operator" ? "crm-badge-blue" : r.key === "finance" ? "crm-badge-green" : "crm-badge-purple"}`}>
                      {r.label}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ALL_MODULES.map((mod) => (
                <tr key={mod}>
                  <td className="primary">{MODULE_LABELS[mod]}</td>
                  {roles.map((r) => {
                    const hasAccess = r.modules.includes(mod);
                    const canReadMod = r.read.includes("all") || r.read.includes(mod);
                    const canWriteMod = r.write.includes("all") || r.write.includes(mod);

                    if (!hasAccess) {
                      return (
                        <td key={r.key} className="text-center">
                          <X className="w-4 h-4 mx-auto" style={{ color: "var(--crm-text-dim)", opacity: 0.4 }} />
                        </td>
                      );
                    }

                    return (
                      <td key={r.key} className="text-center">
                        <div className="flex items-center justify-center gap-2">
                          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-bold"
                            style={{ background: "rgba(16,185,129,0.08)", color: "#10b981", border: "1px solid rgba(16,185,129,0.2)" }}>
                            <Eye className="w-3 h-3" /> Ler
                          </span>
                          {canWriteMod && (
                            <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-bold"
                              style={{ background: "rgba(59,130,246,0.08)", color: "#3b82f6", border: "1px solid rgba(59,130,246,0.2)" }}>
                              <Pencil className="w-3 h-3" /> Editar
                            </span>
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Role descriptions */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {roles.map((r) => (
          <div key={r.key} className="crm-card p-4">
            <span className={`crm-badge mb-2 ${r.key === "admin" ? "crm-badge-red" : r.key === "operator" ? "crm-badge-blue" : r.key === "finance" ? "crm-badge-green" : "crm-badge-purple"}`}>
              {r.label}
            </span>
            <p className="text-xs mt-2" style={{ color: "var(--crm-text-muted)" }}>{r.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
